import Box from '@mui/material/Box'
import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import Link from '@mui/material/Link'
import Typography from '@mui/material/Typography'
import { useTranslate } from '@repo/unicity'
import { localize } from '@/core/utils'

interface TermsDialogProps {
    open: boolean
    onClose: () => void
    title?: { native?: string; english?: string } | string | null
    htmlContent?: { native?: string; english?: string } | string | null
}

export const TermsDialog = ({ open, onClose, title, htmlContent }: TermsDialogProps) => {
    const { translate } = useTranslate()

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            PaperProps={{ sx: { borderRadius: '12px', maxWidth: '700px' } }}
            data-testid="terms-dialog-dialog">
            <Box
                sx={{ p: '30px', maxHeight: '500px', display: 'flex', flexDirection: 'column', fontFamily: "'Inter', 'Noto Sans Thai', sans-serif" }}
                data-testid="terms-dialog-box-typography">
                <Typography sx={{ fontFamily: 'inherit', fontSize: '24px', fontWeight: 700, color: '#003764', mb: 2 }} data-testid="terms-dialog-typography">
                    {localize(title) || 'Unicity Distributor Agreement'}
                </Typography>

                <DialogContent sx={{ p: 0, flex: 1, overflowY: 'auto' }} data-testid="terms-dialog-dialog-content">
                    <Box
                        sx={{
                            fontFamily: 'inherit',
                            fontSize: 14,
                            color: '#153862',
                            lineHeight: 1.8,
                            '& p': { mb: 1.5 },
                            '& b, & strong': { fontWeight: 700 }
                        }}
                        dangerouslySetInnerHTML={{ __html: localize(htmlContent) }}
                        data-testid="terms-dialog-box"
                    />
                </DialogContent>

                <Link
                    component="button"
                    onClick={onClose}
                    sx={{
                        fontFamily: 'inherit',
                        mt: 2,
                        fontSize: 16,
                        fontWeight: 600,
                        color: '#003764',
                        textDecoration: 'underline',
                        cursor: 'pointer',
                        textAlign: 'left'
                    }}
                    data-testid="terms-dialog-link-on-close">
                    {translate('close')}
                </Link>
            </Box>
        </Dialog>
    )
}
